import * as React from 'react'
import { translate } from '../helpers/locale-helper'
import StringTranslation from '../interfaces/string-translation'

type ProviderValue = {
  language: string
  t: <I = string, E = StringTranslation>(value: E) => I
}
export const LanguageContext = React.createContext({} as ProviderValue)
export const useLanguage = () => React.useContext(LanguageContext)

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = ({ props, element }) => {
  const {
    pageContext: { locale },
  } = props

  return (
    <LanguageContext.Provider
      value={{
        language: locale,
        t: translate(locale),
      }}
    >
      {element}
    </LanguageContext.Provider>
  )
}
